// extracted by mini-css-extract-plugin
export default {"shrink-col":"styles_shrink-col__o5+wu","shrinkCol":"styles_shrink-col__o5+wu"};